import { css } from '@emotion/react'

export const avatarStyles = ({ theme }) =>
  css`
      width: 54px;
      height: 54px;

      ${theme.media.mega} {
        width: 72px;
        height: 72px;
      }
    `

export const avatarBigStyles = ({ theme, big }) => big &&
  css`
      width: 100%;
      height: 100%;

    ${theme.media.mega} {
        width: 100%;
        height: 100%;
    }
`

export const baseStyles = ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    font-size: 24px;
    color: ${theme.colors.n700};
    border-radius: 50%;
    background: ${theme.colors.n400};

    ${theme.media.mega} {
      font-size: 32px;
    }
  `

export const imageStyles = ({ theme, image }) => css`
    width: 100%;
    height: 100%;
    background-color: ${theme.colors.n400};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    background-image: url(${image});
  `
